import { render, staticRenderFns } from "./SucRadioFieldComponent.vue?vue&type=template&id=415cdc30&"
import script from "./SucRadioFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SucRadioFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415cdc30')) {
      api.createRecord('415cdc30', component.options)
    } else {
      api.reload('415cdc30', component.options)
    }
    module.hot.accept("./SucRadioFieldComponent.vue?vue&type=template&id=415cdc30&", function () {
      api.rerender('415cdc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SucRadioFieldComponent.vue"
export default component.exports